/**
 * Created by r4zi4l on 05.04.2024
 */

// value: { name, amount }
Reward.register("keys", {
    countable: true,
    getIcon: function (value) {
        return new QuestItemView(value, true);
    },

    parse: function (value, options) {
        return Object.keys(value)
            .filter((name) => value[name])
            .map((name) => new Reward("keys", { name, amount: value[name] }, options));
    },

    receive: function () {
        return function () {};
    }
});
